import type { PilotCsId } from "~domain/devices/models/pilot/pilot-model.ts";

import { z } from "zod";

export const backofficeFindSitePilotsLastConnectionDatesResponseSchema = z
  .object({
    momboxId: z.number().transform((s) => s as PilotCsId),
    lastConnectionDate: z.coerce.date(),
  })
  .array();

export type BackofficeFindSitePilotsLastConnectionDatesResponse = z.infer<
  typeof backofficeFindSitePilotsLastConnectionDatesResponseSchema
>;
